import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {VendorsFilters} from "./vendors-filter.interface";

@Component({
  selector: 'app-vendors-filter',
  templateUrl: './vendors-filter.component.html',
  styleUrls: ['./vendors-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorsFilterComponent implements OnInit {

  filters: VendorsFilters = {
    is_prequalified: '',
    archived: 'false',
    date_range: []
  } as VendorsFilters;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<VendorsFilterComponent>
  ) { }

  ngOnInit() {
    this.filters.is_prequalified = this.data['filter_is_prequalified'] ?? '';
    this.filters.archived = this.data['filter_archived'] ?? 'false';
    this.filters.date_range = this.data['date_range'] ?? [];
  }

  /**
   * Clears the currently selected filters and closes the current view.
   * Calls the onSaveAndClose method after clearing the filter.
   * @return {void}
   */
  onClearAndClose(): void {
    this.filters.is_prequalified = '';
    this.filters.archived = 'false';
    this.filters.date_range = [];

    this.onSaveAndClose();
  }

  /**
   * Saves the current changes and closes the dialog.
   *
   * @return {any}
   */
  onSaveAndClose(): any {
    let response: any;

    response = {
      is_prequalified: this.filters.is_prequalified,
      archived: this.filters.archived,
      date_range: this.filters.date_range
    }

    this.dialogRef.close(response);
  }

  /**
   * Sets the output date range based on the provided event value.
   *
   * @param {any} event - The event value to set the date range.
   * @return {void} - No return value.
   */
  getOutputDateRange(event: any): void {
    this.filters.date_range = event;
  }

  /**
   * Clears the date range for this filter.
   *
   * @returns {void}
   */
  onClearDateRange(): void {
    this.filters.date_range = [];
  }

}
